import React from 'react';
import cn from 'classnames';

import {IColumn, SetOrderByType} from 'shared/ui/Table/Table';
import Sort from 'shared/ui/icons/Sort';
import IOrderBy from 'shared/model/IOrderBy';

import styles from './SortableTh.module.scss';

interface ISortableThProps {
    column: IColumn,
    sort?: IOrderBy,
    setSort?: SetOrderByType,
}

const SortableTh: React.FC<ISortableThProps> = ({
    column,
    sort,
    setSort,
}) => {
    const isActive = sort?.field === column.sort;
    const isAsc = sort?.direction === 'asc';

    const clickHandler = () => {
        if (column.sort) {
            const direction = (isActive && isAsc)
                ? 'desc'
                : 'asc';

            setSort?.({field: column.sort, direction});
        }
    };

    return (
        <th
            className={styles.container}
            onClick={clickHandler}
        >
            <div className={cn(
                styles.content,
                {[styles.active]: isActive},
            )}>
                {column.label}

                <div className={
                    cn(
                        styles.icon,
                        {[styles.active]: isActive},
                        {[styles.desc]: isActive && !isAsc},
                    )
                }>
                    <Sort />
                </div>
                
            </div>
        </th>
    );
};

export default React.memo(SortableTh);